import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Addon as SchemaAddon } from '../schemas/Addon';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Returns list of addons for the specified variant ID considering all binding modes:
- SELECTED_VARIANTS - addons bound to specific variant
- ALL_VARIANTS - addons available for all variants
- SELECTED_CATEGORIES_COLLECTIONS - addons bound to product categories/collections

 * @tags Products
 * @summary Get addons for a product variant
 */
export const GetAddonsByVariantIDContentType = '' as const;
export type GetAddonsByVariantIDRequest = void;
export type GetAddonsByVariantIDResponses = LinkCommonErrorResponses & {
    /**
     * @description List of addons for the variant
     */
    '200': {
        'application/json': SchemaAddon[];
    };
};
export type GetAddonsByVariantIDResponseSuccess = GetAddonsByVariantIDResponses['200']['application/json'];
export type GetAddonsByVariantIDSearchParams = undefined;
export type GetAddonsByVariantIDPathParameters = {
    id: string;
};
export const GetAddonsByVariantIDUrl = '/variants/{id}/addons' as const;
export const GetAddonsByVariantIDMethod = 'GET' as const;
export const getGetAddonsByVariantIDUrl = (params: GetAddonsByVariantIDPathParameters) =>
    GetAddonsByVariantIDUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetAddonsByVariantIDPathParameters) =>
        String(params[param])
    );
